import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { WorkplaceCreate } from "@/api/offices";
import { loadHandbooks } from "@/utils/loadHandbooks";

export const createWorkplaceFields: InputField[] = [
  {
    label: "Название",
    name: "display_name",
    placeholder: "Рабочее место 1",
    type: "text",
    isRequired: true,
  },
];

export function CreateWorkplaceModal({
  disclosure,
  officeId,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  officeId: number;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);
  const handleError = useErrorHandling();

  const onSubmit = (data: WorkplaceCreate) => {
    return new Promise<boolean>((resolve) => {
      setModalErrors([]);
      api.offices.workplaces
        .create(officeId, data)
        .then(() => {
          toast.success("Рабочее место успешно создано!");
          loadHandbooks({ handbooks: ["workplaces"] });
          onOpenChange();
          resolve(true);
        })
        .catch((err) => {
          const { errorMessage, parsedErrors } = handleError(err);
          toast.error(errorMessage);
          setModalErrors(parsedErrors || []);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание рабочего места"
      fields={createWorkplaceFields}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      isSensitiveData={false}
      submitButtonText="Создать"
      defaultValues={{
        display_name: "",
        office_id: officeId,
      }}
    />
  );
}
